<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Profil</h1>
        </div>

        <div class="section-body">
          <div class="card">
            <div class="card-body">
              <div
                id="profil"
                class="row"
              >
                <div
                  class="col-lg-6"
                  style="border-right: 1px solid #eee"
                >
                  <div class="text-center mt-3">
                    <img
                      v-if="user"
                      alt="image"
                      :src="(user.foto) ? $store.getters.getBaseUrl + '/api/file/' + user.foto : require('@/assets/stisla/img/avatar/avatar-1.png')"
                      class="rounded-circle mr-1"
                      style="max-width: 200px"
                    >
                   
                    <div
                      style="position: absolute; width: 200px; height: 200px; top: 0; left: 0; right: 0; margin-left: auto; margin-right: auto"
                    >
                      <button
                        v-b-tooltip
                        v-b-modal="'modal-ganti-foto'"
                        title="Ganti Foto"
                        class="btn btn-link"
                        style="margin-top: 100px"
                      >
                        <i
                          class="fas fa-camera"
                          style="font-size: 1.5rem"
                        />
                      </button>
                    </div>
                  </div>
                  <div
                    class="mt-3"
                    v-if="profile"
                  >
                    <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left">
                        <b>Nama Lengkap</b>
                      </div>
                      <div class="col-lg-6">
                        {{ profile.nama_lengkap }}
                        <button
                          class="btn btn-sm btn-primary"
                          style="border-radius: 20px; position: absolute; right: 20px; top: 0; padding-left: 15px; padding-right: 15px;"
                          @click="$bvModal.show('modal-edit-penduduk')"
                        >
                          <i
                            class="fa mr-2 fa-pencil-alt"
                          />
                          Edit Data
                        </button>
                      </div>
                    </div>
                    <!-- <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left">
                        <b>NIK</b>
                      </div>
                      <div class="col-lg-6">
                        {{ profile.nik }}
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left">
                        <b>Nomor KK</b>
                      </div>
                      <div class="col-lg-6">
                        {{ profile.no_kk }}
                      </div>
                    </div> -->
                    <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left">
                        <b>Tempat Tanggal Lahir</b>
                      </div>
                      <div
                        class="col-lg-6"
                        v-if="profile.tempat_lahir && profile.tanggal_lahir"
                      >
                        {{ profile.tempat_lahir }}, {{ new Date(profile.tanggal_lahir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'}) }}
                      </div>
                      <div
                        v-else
                        class="col-lg-6"
                      >
                        -
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left">
                        <b>Jenis Kelamin</b>
                      </div>
                      <div class="col-lg-6">
                        {{ (profile.id_kelamin) ? ( profile.id_kelamin === 1) ? 'Laki-laki' : 'Perempuan' : '-' }}
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left">
                        <b>Alamat</b>
                      </div>
                      <div class="col-lg-6">
                        {{ profile.alamat }}
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left">
                        <b>Desa</b>
                      </div>
                      <div class="col-lg-6">
                        {{ profile.desa.nama_desa }}
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-lg-6 text-lg-right text-left mb-2">
                        <b>Tanda Tangan Digital</b>
                      </div>
                      <div class="col-lg-6">
                        <TtdPenduduk />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="d-flex">
                    <h4 class="section-title">
                      Akun
                    </h4>
                    <div
                      class="text-right mt-1"
                      style="flex: 1 1 auto"
                    >
                      <button
                        class="btn btn-sm mt-4"
                        :class="(disableForm) ? 'btn-primary' : 'btn-danger'"
                        style="border-radius: 20px; padding-left: 15px; padding-right: 15px"
                        @click="disableForm = !disableForm"
                      >
                        <i
                          class="fa mr-2"
                          :class="(disableForm) ? 'fa-pencil-alt': 'fa-times'"
                        />
                        {{ (disableForm) ? 'Edit' : 'Batal Edit' }}
                      </button>
                    </div>
                  </div>
                  
                  <hr>
                  <form
                    action=""
                    @submit="editAkun"
                  >
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="">Email</label>
                          <input
                            type="email"
                            class="form-control"
                            required
                            v-model="form.email"
                            :disabled="disableForm"
                          >
                        </div>
												
                        <div class="form-group">
                          <label for="">Nomor HP</label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            v-model="form.no_hp"
                            :disabled="disableForm"
                          >
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group">
                          <label for="">Username</label>
                          <input
                            type="text"
                            class="form-control"
                            required
                            v-model="form.username"
                            :disabled="disableForm"
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="!disableForm"
                      class="row"
                    >
                      <div class="col-12">
                        <div class="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            id="editPassword"
                            value="1"
                            v-model="isEditPassword"
                          >
                          <label
                            class="custom-control-label"
                            for="editPassword"
                          >Centang jika ingin mengganti password</label>
                        </div>
                      </div>

                      <div
                        class="col-12 mt-3"
                        v-if="!disableForm && isEditPassword"
                      >
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="form-group">
                              <label for="">Password Baru</label>
                              <div class="input-group mb-3">
                                <input
                                  :type="(!isShowPassword) ? 'password' : 'text'"
                                  class="form-control"
                                  tabindex="2"
                                  required
                                  v-model="form.password"
                                >
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-primary"
                                    type="button"
                                    @click="isShowPassword = !isShowPassword"
                                  >
                                    <i
                                      class="fa"
                                      :class="(!isShowPassword) ? 'fa-eye' : 'fa-eye-slash'"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="form-group">
                              <label for="">Masukkan Ulang Password Baru</label>
                              <div class="input-group mb-3">
                                <input
                                  :type="(!isShowPasswordC) ? 'password' : 'text'"
                                  class="form-control"
                                  tabindex="2"
                                  required
                                  v-model="form.c_password"
                                >
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-primary"
                                    type="button"
                                    @click="isShowPasswordC = !isShowPasswordC"
                                  >
                                    <i
                                      class="fa"
                                      :class="(!isShowPasswordC) ? 'fa-eye' : 'fa-eye-slash'"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="!disableForm"
                      class="mt-4"
                    >
                      <button
                        id="btnSubmitEditAkun"
                        type="submit"
                        class="btn btn-primary"
                      >
                        <i class="fa fa-check mr-2" />
                        Simpan
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div
                v-if="showKK"
                class="row"
              >
                <div class="col-12">
                  <h4 class="section-title">
                    Keluarga
                  </h4>
                  <hr>
                  <div v-if="profile">
                    <p>Nomor KK: <b>{{ profile.no_kk }}</b></p>
                    <div class="table-responsive">
                      <table class="table table-md">
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>Nama</th>
                            <th>NIK</th>
                            <th>Tempat Tanggal Lahir</th>
                            <th>SHDK</th>
                            <th>Jenis Kelamin</th>
                            <th>Pendidikan Terakhir</th>
                            <th>Pekerjaan</th>
                            <th>Agama</th>
                            <th>Status Perkawinan</th>
                            <th>Nama Ayah</th>
                            <th>Nama Ibu</th>
                            <th>Alamat</th>
                          </tr>
                        </thead>
                        <tbody v-if="anggotaKk.length > 0">
                          <tr
                            v-for="(a, i) in anggotaKk"
                            :key="a.id_penduduk"
                          >
                            <td>{{ i + 1 }}</td>
                            <td>{{ a.nama_lengkap }}</td>
                            <td>{{ a.nik }}</td>
                            <td v-if="a.tempat_lahir && a.tanggal_lahir">
                              {{ a.tempat_lahir }}, {{ new Date(a.tanggal_lahir).toLocaleDateString('id-ID', {year: 'numeric', month: 'long', day: 'numeric'}) }}
                            </td>
                            <td v-else>
                              -
                            </td>
                            <td>{{ (a.shdk) ? a.shdk.nama_shdk : '-' }}</td>
                            <td>{{ (a.id_kelamin == 1) ? 'Laki-laki' : 'Perempuan' }}</td>
                            <td>{{ a.pend_terakhir }}</td>
                            <td>{{ a.pekerjaan }}</td>
                            <td>{{ (a.agama) ? a.agama.nama_agama : '-' }}</td>
                            <td>{{ a.status_kawin }}</td>
                            <td>{{ a.nama_lengkap_ayah }}</td>
                            <td>{{ a.nama_lengkap_ibu }}</td>
                            <td>{{ a.alamat }}</td>
                          </tr>
                        </tbody>
                        <tbody v-if="anggotaKk.length === 0">
                          <tr>
                            <td
                              colspan="13"
                              class="text-center"
                            >
                              Tidak ada data
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <b-modal
      hide-footer
      id="modal-ganti-foto"
      size="lg"
      title="Ganti Foto"
    >
      <ImageCropper
        @saveProfilImage="saveProfilImage"
      />
    </b-modal>

    <b-modal
      id="modal-edit-penduduk"
      title="Edit Data"
      size="lg"
      hide-footer
    >
      <FormPenduduk
        aksi="edit-profil"
        @completedProsesPenduduk="completedProsesPenduduk"
      />
    </b-modal>
  </LayoutAdmin>
</template>

<style scoped>
  #profil .btn-link {
    color: #ffffff;
  }
  #profil .btn-link:hover, #profil .btn-link:active, #profil .btn-link:focus {
    color: #6777ef;
    background: transparent;
  }
</style>

<script>
import swal from 'sweetalert'
import LayoutAdmin from '../layouts/Admin.vue'
import TtdPenduduk from '../../components/profile/TtdPenduduk.vue'
import ImageCropper from '../../components/global/ImageCropper.vue'
import FormPenduduk from '../../components/global/FormPenduduk.vue'


export default {
	name: 'Profil',
	data(){
		return {
      disableForm: true, // form edit akun
      showKK: false, // setting nampilin data kk apa nggak
			form: {
				email: '',
				username: '',
				no_hp: '',
				password: '',
				c_password: '',
			},
			isEditPassword: false,
      isShowPassword: false,
      isShowPasswordC: false,
			anggotaKk: [],
      
      imgSrc: require('@/assets/stisla/img/avatar/avatar-1.png'),
      cropImg: '',
      dataImg: null,
		}
	},
	computed: {
		profile(){
			return this.$store.getters.getUserProfile
		},
		user(){
			return this.$store.getters.getUser
		}
	},
	components: {
		LayoutAdmin, TtdPenduduk, ImageCropper, FormPenduduk
	},
	methods: {
		editAkun(e){
			e.preventDefault()

      if(this.disableForm){
        swal({
            title: "Kesalahan",
            text: "Tidak diizinkan",
            icon: "error",
            buttons: "Ok"
        })
        return false
			}

			if(this.isEditPassword){
				if(this.form.password != this.form.c_password){
					swal({
              title: "Kesalahan",
              text: "Password yang dimasukkan tidak sama",
              icon: "error",
              buttons: "Ok"
          })
					return false
				}
        // password
        if(this.form.password.length < 8){
          swal({
              title: "Kesalahan",
              text: "Password minimal terdiri dari 8 huruf",
              icon: "error",
              buttons: "Ok"
          })
					return false
        }
        if(!/[a-z]/.test(this.form.password) || !/[A-Z]/.test(this.form.password) || !/\d/.test(this.form.password)){
          swal({
              title: "Kesalahan",
              text: "Password harus terdiri dari huruf besar, huruf kecil, dan angka",
              icon: "error",
              buttons: "Ok"
          })
					return false
        }
			}

      // no_hp
			if(this.form.no_hp.length < 10 || this.form.no_hp.length > 15){
				swal({
            title: "Kesalahan",
            text: "Nomor HP Tidak Valid",
            icon: "error",
            buttons: "Ok"
        })
        return false
			}
      
      // username
      if(this.form.username.length < 8){
        swal({
            title: "Kesalahan",
            text: "Username minimal terdiri dari 8 huruf",
            icon: "error",
            buttons: "Ok"
        })
        return false
			}
			if(this.form.username.includes(' ')){
        swal({
            title: "Kesalahan",
            text: "Username tidak boleh berisi spasi",
            icon: "error",
            buttons: "Ok"
        })
        return false
			}

      let confirmMsg = 'Yakin ingin edit akun?'

      if (this.form.email !== this.user.email) {
        confirmMsg = 'Yakin ingin edit akun? Mengedit email akun memerlukan verifikasi ulang.'
      }

      swal({
        title: "Konfirmasi",
        text: confirmMsg,
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, simpan",
            value: "ok",
          },
        }
      }).then( val => {
        if (val === 'ok') {
          let button = document.querySelector('#btnSubmitEditAkun')
          let buttonHtml = button.innerHTML

          button.setAttribute('disabled', true)
          button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Simpan'


          let formData = new FormData()

          formData.append('email', this.form.email)
          formData.append('username', this.form.username)
          formData.append('no_hp', this.form.no_hp)

          if (this.isEditPassword) formData.append('password', this.form.password)

          if (this.form.email !== this.user.email) formData.append('email_verified_at', '1')

          let form = {
            id: this.user.id_user,
            data: formData
          }

          this.$store.dispatch('updateAkun', form).then(res => {
            if(res.data.status){
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
              localStorage.removeItem('authService')
              localStorage.removeItem('fcmToken')
              sessionStorage.clear()
              this.$store.dispatch('logoutUser')
              window.location = '/login'
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
            this.disableForm = true
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
          }).catch(err => {
            this.disableForm = true
            switch(err.response.status){
              case 500:
                this.$router.push({path: '/500'})
                break;

              case 400:
                swal({
                  title: "Gagal",
                  text: (typeof(err.response.data.message) === 'object') ? 'Ada kesalahan teknis. Harap hubungi operator' : err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;
              
              default:
                swal({
                  title: "Gagal",
                  text: err.response.data.message,
                  icon: "error",
                  buttons: "Ok"
                })
                break;
            }
            button.removeAttribute('disabled')
            button.innerHTML = buttonHtml
          })
        }
      })
		},
		setForm(data){
            for (let key in this.form){
                if(data[key]){
                    this.form[key] = data[key]
                }
            }
		},
		setKeluarga(data){
			// let no_kk = '5101010102100007'
			let no_kk = data.no_kk
			this.$store.dispatch('fetchAnggotaKkPenduduk', no_kk).then(res => {
				if(res.data.status){
					this.anggotaKk = res.data.data
				}
			})
		},
    saveProfilImage(fileImg){
      let form = new FormData
      form.append('foto', fileImg, 'image.png')

      const loader = document.createElement('div')
      loader.innerHTML = '<div class="overlay-page-loader"><div class="spinner"></div></div>'
      document.querySelector('#app').appendChild(loader)
      
      this.$store.dispatch('updateFotoProfil', form).then(res => {
        this.$store.dispatch('fetchUser').then(resp => {
          this.$bvModal.hide('modal-ganti-foto')
          document.querySelector('.overlay-page-loader').remove()
				}).catch(err => {
          document.querySelector('.overlay-page-loader').remove()
					if(err.response.status === 401){
						this.$store.dispatch('logoutUser')
					} else if(err.response.status === 500){
						this.$router.push({path: '/500'})
					}
				})
      })
    },
    completedProsesPenduduk(){
      this.$store.dispatch('fetchUserProfile').then(res => {
        this.profile = this.$store.getters.getUserProfile
        this.$bvModal.hide('modal-edit-penduduk')
      })
    }
	},
	created(){
		if(this.user){
			this.setForm(this.user)
		}
		if(this.showKK && this.profile){
			this.setKeluarga(this.profile)
		}
	},
	watch:{
		user(newVal){
			this.setForm(newVal)
		},
		profile(newVal){
			this.setKeluarga(newVal)
		}
	}
}
</script>

<style>

</style>
